import { render, staticRenderFns } from "./ValuationsTable.vue?vue&type=template&id=16b7e564&"
import script from "./ValuationsTable.vue?vue&type=script&lang=js&"
export * from "./ValuationsTable.vue?vue&type=script&lang=js&"
import style0 from "./ValuationsTable.vue?vue&type=style&index=0&id=16b7e564&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports